import { Row, Slider as AntSlider } from 'antd';
import React from 'react';

import Slider from '../Slider.style';

type SliderComponentProps = React.ComponentProps<typeof AntSlider>;
type SliderProps = Pick<SliderComponentProps, 'defaultValue' | 'step' | 'min' | 'max' | 'marks' | 'tipFormatter'>;

interface SliderFormProps {
    label: string;
    displayField?: boolean;
    value: number;
    onChange: (a: number) => void;
}

const SliderFormGroup: React.FC<SliderProps & SliderFormProps> = ({ onChange, value, min, max, marks, label, step, tipFormatter }) => {
    return (
        <>
            <div style={{ gridColumn: 1 }}>
                <strong>{label}</strong>
            </div>
            <div style={{ gridColumn: '2 / 6', paddingRight: 15 }}>
                <Row style={{ width: '100%' }}>
                    <div style={{ width: '100%' }}>
                        <Slider
                            style={{ width: '100%' }}
                            step={step}
                            defaultValue={value}
                            value={value}
                            min={min}
                            max={max}
                            marks={marks}
                            onChange={onChange}
                            tipFormatter={tipFormatter}
                        />
                    </div>
                </Row>
            </div>
        </>
    );
};

export default React.memo(SliderFormGroup);
